import { toast as shadcnToast } from "@/hooks/use-toast";

/**
 * Utility toast functions that wrap shadcn toast to match sonner's API
 * This makes it easier to migrate from sonner to shadcn toast
 */
export const toast = {
  /**
   * Display a success toast message
   */
  success: (message: string) => {
    return shadcnToast({
      title: "Success",
      description: message,
      variant: "default",
    });
  },
  
  /**
   * Display an error toast message
   */
  error: (message: string) => {
    return shadcnToast({
      title: "Error",
      description: message,
      variant: "destructive",
    });
  },
  
  /**
   * Display an info toast message
   */
  info: (message: string) => {
    return shadcnToast({
      title: "Info",
      description: message,
      variant: "default",
    });
  },
  
  /**
   * Display a warning toast message
   */
  warning: (message: string) => {
    return shadcnToast({
      title: "Warning",
      description: message,
      variant: "destructive",
    });
  },
  
  /**
   * Display a custom toast message
   */
  custom: (title: string, message: string, variant: "default" | "destructive" = "default") => {
    return shadcnToast({
      title,
      description: message,
      variant,
    });
  },
  
  /**
   * Display a generic toast message
   */
  message: (message: string) => {
    return shadcnToast({
      description: message,
    });
  },
}; 